<template>
  <div class="box addTreatmentProgramBox">
    <p class="xPadding titleModal">
      {{ $t(`treatmentProgram.step1.title`) }}
    </p>
    <v-row
      v-for="(key, index) in keys"
      :key="index"
      class="xPadding"
    >
      <v-col class="noYPadding">
        <v-checkbox
          v-model="data[key]"
          class="check"
          hideDetails
          :label="$t(`treatmentProgram.step1.${key}`)"
          color="primary"
          @change="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'Function',
    props: {
        function: {
            type: Object,
            default: () => {},
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            data: {},
            keys: ['fouling', 'scaling', 'corrosion', 'microbiological', 'other'],
        };
    },
    computed: {
        ...mapGetters([
            'units',
        ]),
    },
    watch: {
        function: {
            handler() {
                this.data = { ...this.data, ...cloneDeep(this.function) };
            },
            immediate: true,
        },
    },
    methods: {
        updateData() {
            this.$emit('sendData', { function: this.data });
        },
        displayedUnits(type) {
            return this.units && this.units[type] ? this.units[type] : [];
        },
    },
};
</script>
<style lang="scss" scoped>
.xPadding{
  padding: 0 6rem;
}
.noYPadding {
    padding-bottom: 0px;
    padding-top: 0px;
}
.check {
    border: 1px solid #8D969F;
    border-radius: 4px;
    padding: 10px 5px;
    height: 56px;
}
.box {
    margin: auto;
    width: 650px;
}

@media screen and (max-width: 600px) {
   .xPadding{
      padding: 0;
    }
    .text-field-transparent{
      margin-bottom:20px;
    }
}

@media screen and (max-width: 800px) {
   .addTreatmentProgramBox {
     width: 100% !important;
   }
}

</style>

<style lang="scss">
  .addTreatmentProgramBox .v-input--selection-controls__input {
    margin-left: 5px;
  }
</style>
